import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoopingItemsComponent from '../LoopingItemsComponent/LoopingItemsComponent';
import _get from 'lodash/get';
import { fieldTypes } from '../../utils/constants';

var LoopingItems =
/*#__PURE__*/
function (_Component) {
  _inherits(LoopingItems, _Component);

  function LoopingItems() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LoopingItems);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LoopingItems)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.componentDidUpdate = function (prevProps) {
      var _this$props = _this.props,
          fields = _this$props.fields,
          loopingGroup = _this$props.loopingGroup,
          handleChange = _this$props.handleChange;

      if (!fields.length && loopingGroup.isLoopingGroupRequired) {
        _this.appendEmptyItem();
      }

      if (prevProps.fields.length !== fields.length) {
        handleChange(fields.name, fields.getAll());
      }
    }, _this.appendEmptyItem = function () {
      var fields = _this.props.fields;
      fields.push(null);
    }, _this.deleteItemFromArray = function (index) {
      _this.props.fields.remove(index);
    }, _this.deleteFileItemFromArray = function (index, member) {
      var _this$props2 = _this.props,
          loopingGroup = _this$props2.loopingGroup,
          handleChange = _this$props2.handleChange;

      var fieldId = _get(loopingGroup, 'fields[0].id');

      handleChange("".concat(member, ".").concat(fieldId));
      setTimeout(function () {
        return _this.props.fields.remove(index);
      }, 500);
    }, _this.isLoopingGroupDocUploadType = function (loopingGroup) {
      if (loopingGroup.fields.length !== 1) {
        return false;
      }

      var fieldItemType = _get(loopingGroup, 'fields[0].formType');

      if (fieldItemType === fieldTypes.DOCUMENT_UPLOAD) {
        return true;
      }

      return false;
    }, _this.renderRemoveButton = function (loopingGroup, index, member) {
      var fields = _this.props.fields;

      if (!_this.isLoopingGroupDocUploadType(loopingGroup) && (index !== 0 || !loopingGroup.isLoopingGroupRequired)) {
        return React.createElement('button', {
          className: 'Btn-default-small Btn-outline-danger Btn-deleteItemFromArray',
          onClick: function onClick() {
            return _this.deleteItemFromArray(index);
          }
        }, 'Remove');
      }

      if (_this.isLoopingGroupDocUploadType(loopingGroup) && (index !== 0 || !loopingGroup.isLoopingGroupRequired) && index === fields.length - 1) {
        return React.createElement('button', {
          className: 'Btn-default-small Btn-outline-danger Btn-deleteItemFromArray',
          onClick: function onClick() {
            return _this.deleteFileItemFromArray(index, member);
          }
        }, 'Remove');
      }

      return null;
    }, _temp));
  }

  _createClass(LoopingItems, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          fields = _this$props3.fields,
          _this$props3$meta = _this$props3.meta,
          error = _this$props3$meta.error,
          submitFailed = _this$props3$meta.submitFailed,
          loopingGroup = _this$props3.loopingGroup,
          uploadingFiles = _this$props3.uploadingFiles,
          files = _this$props3.files,
          handleChange = _this$props3.handleChange,
          allFormFields = _this$props3.allFormFields,
          country = _this$props3.country,
          language = _this$props3.language;
      return React.createElement('ul', {
        className: 'list-unstyled'
      }, fields.map(function (member, index) {
        return React.createElement('div', {
          className: 'looping-group',
          key: index
        }, React.createElement('li', null, React.createElement(LoopingItemsComponent, {
          member: member,
          allFormFields: allFormFields,
          loopingGroup: loopingGroup,
          handleChange: handleChange,
          uploadingFiles: uploadingFiles,
          files: files,
          country: country,
          language: language
        })), _this2.renderRemoveButton(loopingGroup, index, member));
      }), React.createElement('li', null, React.createElement('button', {
        className: 'Btn-default-small Btn-outline-primary',
        type: 'button',
        onClick: this.appendEmptyItem
      }, 'Add ', React.createElement('span', {
        isolate: 'true'
      }, loopingGroup.title)), submitFailed && error && React.createElement('span', null, error)));
    }
  }]);

  return LoopingItems;
}(Component);

LoopingItems.propTypes = {
  fields: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  loopingGroup: PropTypes.object.isRequired
};
export default LoopingItems;